import { render } from "./CurrenciesCard.vue?vue&type=template&id=137c3547"
import script from "./CurrenciesCard.vue?vue&type=script&lang=js"
export * from "./CurrenciesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__